import React from 'react';
import Microapp from '@/components/micro-app';
import env from '@/env';
// 主题活动会场
import { data as defaultData } from '../../constants';
// 我的创建
import createData from '@/pages/activity-manage/my-create/constants/data';
// 新版日常活动
import dailyData from '@/pages/activity-manage/my-create/daily-activities-details-manager/material-pool-manage/material-collection-daily/my-micro-app/data';
// 频道列表
import channelServiceData from '@/pages/channel-service/pages/channel/open-registration-process/collection-list/constants/data';
// 阵地资源位，行业频道
import { platformData, industryData } from '@/pages/platform-marketing-position/resource-detail/contants/data';

const allEnvData = { avenueData: defaultData, channelServiceData, createData, dailyData, platformData, industryData };

// import VenueMicroWrapper from '../venue-micro-wrapper';

function SceneSetting(props: any) {
  const { data = defaultData, ..._props } = props;
  return (
    <Microapp
      data={{ ...allEnvData, ...data }}
      // http://mcbeta.jd.com/dist/pages/activeManageBlock/?entry=0&activityId=10599231
      url={`${env.MC_DOMAIN}/dist/pages/batch/list/`}
      name="scenesettings"
      {..._props}
    />
  );
}

export default SceneSetting;
